export default __webpack_public_path__ + "static/media/hotei13.18c8e683.webp";